/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-07-14 10:11:08
 * @LastEditors: linxi
 * @LastEditTime: 2025-07-21 11:34:42
 */
import { Button, Col, DatePicker, Form, Input, Modal, Row, Select } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import React, { useEffect, useState } from 'react'
import {
  DateTimeFormat,
  DateTimeFormatSimple,
  DateTimeFormatSimpleOnlyOne,
  DateTimeFormatSimplePrintCharge,
} from '../../../models/datetime'
import { unwrapResult } from '@reduxjs/toolkit'
import moment from 'moment'
import { selectUserId } from '../../../app/applicationSlice'
import { getUserList } from '../../user/userSlice'
import { getDBManagementDetailAsync } from '../disqualificationBreakageManagement/disqualificationBreakageManagementSlice'
import styles from './unqualifiedMedicinesLedger.module.css'
const { Option } = Select

export const DetailModal = (props: {
  editTenantId?: any
  id?: any
  isModalVisible: boolean
  onOk: () => void
  onCancel: () => void
}) => {
  const [form] = Form.useForm()

  const userId = useSelector(selectUserId)

  const dispatch = useDispatch<RootDispatch>()

  const [selectData, setSelectData] = useState<any>()

  const [confirmLoading, setConfirmLoading] = useState(false)

  const [userList, setUserList] = useState<any>()

  const [detail, setDetail] = useState<any>()
  
  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 15 },
  }

  useEffect(() => {
    if (props.isModalVisible) {
      dispatch(getUserList({ current: 1, size: 1000, state: 1 }))
        .then(unwrapResult)
        .then((res: any) => {
          setUserList(res?.items)
        })
    }
  }, [props.isModalVisible])

  const getDetail = () => {
    dispatch(
      getDBManagementDetailAsync({
        id: props?.id,
        tenantId: props?.editTenantId,
      })
    )
      .then(unwrapResult)
      .then((v: any) => {
        setDetail(v)
        setSelectData({ ...v, name: v?.tenantMaterialsName })
        form.setFieldsValue({
          ...v,
          reportLossUser:
            v?.reportLossUser && v?.reportLossUser != -1
              ? v?.reportLossUser?.toString()
              : undefined,
          periodValidity: v?.periodValidity
            ? moment(v?.periodValidity)
            : undefined,
          reportLossDate: v?.reportLossDate
            ? moment(v?.reportLossDate)
            : undefined,
          reportLossPrice:
            v?.reportLossPrice > 0 ? v?.reportLossPrice?.toFixed(2) : undefined,
        })
      })
  }

  useEffect(() => {
    if (props.isModalVisible) {
      if (props?.id) {
        getDetail()
      }
    } else {
      form.resetFields()
      setSelectData('')
      setDetail({})
      setUserList([])
    }
  }, [props.isModalVisible])
  return (
    <Modal
      width={1000}
      title={'查看'}
      visible={props.isModalVisible}
      footer={null}
      className={styles.modal}
      maskClosable={false}
      destroyOnClose={false}
      onCancel={() => {
        props.onCancel()
      }}
      onOk={() => {
        props?.onOk()
      }}
    >
      <Form form={form}>
        <Row>
          <Col span={12}>
            <Form.Item
              {...layout}
              label='商品名'
              name='tenantMaterialsName'
              rules={[
                {
                  required: true,
                  message: '商品名不能为空',
                },
              ]}
            >
              <Input placeholder='商品名' disabled />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...layout} label='规格' name='spec'>
              <Input placeholder='规格' disabled />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...layout} label='厂家' name='originName'>
              <Input placeholder='厂家' disabled />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...layout} label='剂型' name='doseCategory'>
              <Input placeholder='剂型' disabled />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...layout} label='批号' name='batchNo'>
              <Input placeholder='批号' disabled />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...layout} label='单位' name='unit'>
              <Input placeholder='单位' disabled />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...layout} label='供应商' name='supplierName'>
              <Input placeholder='供应商' disabled />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...layout} label='有效期' name='periodValidity'>
              <DatePicker
                disabled
                style={{ width: '100%' }}
                placeholder='出生日期'
                format={DateTimeFormatSimple}
                onChange={() => {
                  return
                }}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              {...layout}
              label='报损数量'
              name='reportLossNumber'
              rules={[
                {
                  required: true,
                  message: '报损数量不能为空',
                },
                {
                  message: '请输入最多带两位小数的数值',
                  pattern: new RegExp(/^[0-9]+((\.)[0-9]{0,2})?$/),
                },
              ]}
            >
              <Input placeholder='报损数量' disabled />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...layout} label='报损金额' name='reportLossPrice'>
              <Input placeholder='报损金额' disabled />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...layout} label='报损原因' name='reportLossReason'>
              <Input placeholder='报损原因' disabled />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              {...layout}
              label='报损日期'
              name='reportLossDate'
              rules={[
                {
                  required: true,
                  message: '报损日期不能为空',
                },
              ]}
            >
              <DatePicker
                disabled
                style={{ width: '100%' }}
                placeholder='报损日期'
                format={DateTimeFormatSimple}
                onChange={() => {
                  return
                }}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...layout} label='报损人' name='reportLossUser'>
              <Select placeholder='报损人' allowClear disabled>
                {userList?.map((v: any, i: any) => {
                  return (
                    <Option value={v?.id} key={i}>
                      {v?.name}
                    </Option>
                  )
                })}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...layout} label='处理意见' name='handleSuggestion'>
              <Input placeholder='处理意见' disabled />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...layout} label='处理结果' name='handleResult'>
              <Input placeholder='处理结果' disabled />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...layout} label='备注' name='remark'>
              <Input placeholder='备注' disabled />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}
